import './index.css';

export default function LoadingScreen() {
  return (
    <div className="full-vh full-vw loading-screen-wrapper d-flex j-center align-center fade-in">
      <div className="fw500 primary-color">VPay Merchant</div>
    </div>
  );
}
